import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ontos-code"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parts, (part, index) => {
    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
      (index % 2)
        ? (_openBlock(), _createElementBlock("code", _hoisted_1, _toDisplayString(part), 1))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(part), 1)
          ], 64))
    ], 64))
  }), 128))
}